import {
  RESET_VALUES,
  RESET_FILTERS,
  UPDATE_PAGE_NO,
  UPDATE_SEARCH_INPUT,
  UPDATE_START_DATE,
  UPDATE_END_DATE,
  UPDATE_SORT_BY,
  UPDATE_SORT_ORDER,
  UPDATE_ROWS_PER_PAGE,
  UPDATE_TOTAL_COUNT,
  UPDATE_DISPLAY_ACTIVE,
  UPDATE_FILTER_TYPES,
  UPDATE_FILTER_TEMPLATES,
  UPDATE_FILTER_PRODCT_NAMES,
  UPDATE_FILTER_PRODUCT_CATEGORIES,
  UPDATE_FILTER_EVENT_TYPE_CATEGORIES,
  UPDATE_FILTER_OCCURRENCE_TYPES,
  UPDATE_FILTER_MARKETING_TYPES,
  UPDATE_FILTER_TAGS,
  CLEAR_TABLE_AND_TOOLBAR_STORE,
  UPDATE_PAGINATED_FILTERS,
  UPDATE_FILTER_PAGINATED_TEMPLATES,
  UPDATE_FILTER_PAGINATED_CAMPAIGNS,
  UPDATE_FILTER_EVENT_IDENTIFIER_VALUES,
  UPDATE_FILTER_SURVEY_QUESTIONS,
  UPDATE_FILTER_GUEST_INFO_VALUES,
  UPDATE_FILTER_CONTACT_INFO_VALUES,
  UPDATE_FILTER_CONSENT_VALUES
} from './actions';
import { createReducer } from '@reduxjs/toolkit';

const initialState = {
  pageNo: 0,
  searchInput: '',
  sortBy: 'name',
  sortOrder: 'ASC',
  rowsPerPage: 10,
  totalCount: 0,
  displayActive: true,
  filterTypes: [],
  filterTemplates: [],
  filterProductNames: [],
  filterProductCategories: [],
  filterEventTypeCategories: [],
  filterOccurrenceTypes: [],
  filterMarketingTypes: [],
  filterTags: [],
  filterStartDate: null,
  filterEndDate: null,
  filterPaginatedTemplates: [],
  filterPaginatedCampaigns: [],
  filterEventIdentifierValues: [],
  filterGuestInfoValues: [],
  filterContactInfoValues: [],
  filterConsentValues: [],
  filterSurveyQuestions: [],
  paginatedFilters: {
    pageNo: 0,
    searchInput: '',
    rowsPerPage: 10,
    totalCount: 0,
    activeTemplateFilter: null,
    activeCampaignFilter: null
  }
};

export default createReducer(initialState, {
  [UPDATE_PAGE_NO]: (state, action) => {
    state.pageNo = action.payload;
    return state;
  },
  [UPDATE_SEARCH_INPUT]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.searchInput = action.payload;
    return state;
  },
  [UPDATE_START_DATE]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.filterStartDate = action.payload;
    return state;
  },
  [UPDATE_END_DATE]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.filterEndDate = action.payload;
    return state;
  },
  [UPDATE_SORT_BY]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.sortBy = action.payload;
    return state;
  },
  [UPDATE_SORT_ORDER]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.sortOrder = action.payload;
    return state;
  },
  [RESET_VALUES]: () => {
    return initialState;
  },
  [RESET_FILTERS]: state => {
    state.pageNo = initialState.pageNo;
    state.filterTypes = initialState.filterTypes;
    state.filterTemplates = initialState.filterTemplates;
    state.filterProductNames = initialState.filterProductNames;
    state.filterProductCategories = initialState.filterProductCategories;
    state.filterEventTypeCategories = initialState.filterEventTypeCategories;
    state.filterOccurrenceTypes = initialState.filterOccurrenceTypes;
    state.filterMarketingTypes = initialState.filterMarketingTypes;
    state.filterTags = initialState.filterTags;
    state.filterStartDate = initialState.filterStartDate;
    state.filterEndDate = initialState.filterEndDate;
    state.paginatedFilters = initialState.paginatedFilters;
    state.filterPaginatedTemplates = initialState.filterPaginatedTemplates;
    state.filterPaginatedCampaigns = initialState.filterPaginatedCampaigns;
    state.filterEventIdentifierValues = initialState.filterEventIdentifierValues;
    state.filterGuestInfoValues = initialState.filterGuestInfoValues;
    state.filterContactInfoValues = initialState.filterContactInfoValues;
    state.filterConsentValues = initialState.filterConsentValues;
    state.filterSurveyQuestions = initialState.filterSurveyQuestions;
    return state;
  },
  [UPDATE_ROWS_PER_PAGE]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.rowsPerPage = action.payload;
    return state;
  },
  [UPDATE_TOTAL_COUNT]: (state, action) => {
    state.totalCount = action.payload;
    if (action.payload === 0) {
      state.pageNo = initialState.pageNo;
    }
    return state;
  },
  [UPDATE_DISPLAY_ACTIVE]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.displayActive = action.payload;
    return state;
  },
  [UPDATE_FILTER_TYPES]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.filterTypes = action.payload;
    return state;
  },
  [UPDATE_FILTER_TEMPLATES]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.filterTemplates = action.payload;
    return state;
  },
  [UPDATE_FILTER_PRODCT_NAMES]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.filterProductNames = action.payload;
    state.filterPaginatedTemplates = [];
    state.filterPaginatedCampaigns = [];
    state.filterEventIdentifierValues = [];
    return state;
  },
  [UPDATE_FILTER_PRODUCT_CATEGORIES]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.filterProductCategories = action.payload;
    return state;
  },
  [UPDATE_FILTER_EVENT_TYPE_CATEGORIES]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.filterEventTypeCategories = action.payload;
    return state;
  },
  [UPDATE_FILTER_EVENT_IDENTIFIER_VALUES]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.filterEventIdentifierValues = action.payload;
    return state;
  },
  [UPDATE_FILTER_GUEST_INFO_VALUES]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.filterGuestInfoValues = action.payload;
    return state;
  },
  [UPDATE_FILTER_CONTACT_INFO_VALUES]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.filterContactInfoValues = action.payload;
    return state;
  },
  [UPDATE_FILTER_CONSENT_VALUES]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.filterConsentValues = action.payload;
    return state;
  },
  [UPDATE_FILTER_SURVEY_QUESTIONS]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.filterSurveyQuestions = action.payload;
    return state;
  },
  [UPDATE_FILTER_OCCURRENCE_TYPES]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.filterOccurrenceTypes = action.payload;
    return state;
  },
  [UPDATE_FILTER_MARKETING_TYPES]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.filterMarketingTypes = action.payload;
    return state;
  },
  [UPDATE_FILTER_PAGINATED_TEMPLATES]: (state, action) => {
    let filterPaginatedTemplates = new Map(state.filterPaginatedTemplates.map(item => [item.value, item]));
    action.payload.forEach(item => filterPaginatedTemplates.set(item.value, item));
    state.pageNo = initialState.pageNo;
    state.filterPaginatedTemplates = Array.from(filterPaginatedTemplates.values()).filter(option => option.checked);
    return state;
  },
  [UPDATE_FILTER_PAGINATED_CAMPAIGNS]: (state, action) => {
    let filterPaginatedCampaigns = new Map(state.filterPaginatedCampaigns.map(item => [item.value, item]));
    action.payload.forEach(item => filterPaginatedCampaigns.set(item.value, item));
    state.pageNo = initialState.pageNo;
    state.filterPaginatedCampaigns = Array.from(filterPaginatedCampaigns.values()).filter(option => option.checked);
    return state;
  },
  [UPDATE_FILTER_TAGS]: (state, action) => {
    state.pageNo = initialState.pageNo;
    state.filterTags = action.payload;
    return state;
  },
  [CLEAR_TABLE_AND_TOOLBAR_STORE]: state => {
    return {
      ...initialState,
      rowsPerPage: state.rowsPerPage
    };
  },
  [UPDATE_PAGINATED_FILTERS]: (state, action) => {
    state.paginatedFilters = { ...state.paginatedFilters, ...action.payload };
    return state;
  }
});
